
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M20.105 29.887a.877.877 0 010-.83c1.681-3.11 4.788-5.807 7.895-5.807 3.107 0 6.214 2.696 7.895 5.807.14.259.14.573 0 .831-1.681 3.11-4.788 5.807-7.895 5.807-3.107 0-6.213-2.696-7.895-5.808z","fill":"#F9B621","stroke":"#363636","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M29.886 27.587a2.667 2.667 0 11-3.772 3.771 2.667 2.667 0 013.772-3.771z","fill":"#fff"}}),_c('path',{attrs:{"d":"M8 12.672h15.678M8 19.341h8.34M8 27.01h5.674","stroke":"#363636","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    